// src/constants/users.ts
import type { AppUser } from "@/types/user";

// ====================== LEGACY (для постепенной миграции) ======================
export const LEGACY_USERS = [
  { id: 1, name: "Андреев Алексей Евгеньевич" },
  { id: 2, name: "Багаутдинов Ахмет Айратович" },
  { id: 3, name: "Барладян Ирина Алексеевна" },
  { id: 4, name: "Павлик Кристина Валентиновна" },
  { id: 5, name: "Исаенко Алена Андреевна" },
  { id: 6, name: "Кременецкая Галина Сергеевна" },
  { id: 7, name: "Локтионова Дарья Петровна" },
] as const;

// Старые цепочки согласования — оставляем пока для совместимости
export const APPROVAL_CHAINS_BY_ID: Record<number, number[]> = {
  7: [3, 2, 1],
  6: [4, 2, 1],
  5: [2, 1],
  4: [2, 1],
  3: [2, 1],
  2: [1],
  1: [],
};

export const USERS_WITHOUT_APPROVAL_BUTTONS = [5, 6, 7] as const;

// ====================== НОВАЯ СИСТЕМА ======================

// Вспомогательные утилиты
export const getNumericId = (id: string | number): number => {
  return typeof id === 'string' ? parseInt(id, 10) : id;
};

// Получить пользователя по ID из массива
export const getUserById = (users: AppUser[], id: string | number): AppUser | null => {
  const numId = getNumericId(id);
  return users.find(u => u.numericId === numId) || null;
};

// Получить всех пользователей конкретной организации
export const getUsersByOrganization = (users: AppUser[], organizationId: string): AppUser[] => {
  return users.filter(u => u.organizationId === organizationId);
};

// Получить пользователей, которые могут создавать задачи в организации
export const getTaskCreatorsByOrganization = (users: AppUser[], organizationId: string): AppUser[] => {
  return getUsersByOrganization(users, organizationId)
    .filter(u => u.canCreateTask && u.active);
};

export default {
  LEGACY_USERS,
  APPROVAL_CHAINS_BY_ID,
  USERS_WITHOUT_APPROVAL_BUTTONS,
  getNumericId,
  getUserById,
  getUsersByOrganization,
  getTaskCreatorsByOrganization,
};